import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class UnedaService {

  public url: string;
  public token: string;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url + '/unedainventory/';
    this.token = JSON.parse(localStorage.getItem('token'));
    if (this.token === 'undefined') {
      this.token = null;
    }
  }

  getAll(type = null): Observable<any> {
    let endpoint = 'listbyfather/1';
    if (type !== null) {
      endpoint = endpoint + '/' + type;
    }
    return this.sendRequest(this.url + endpoint + '?page=1', null);
  }

  private sendRequest(url: string, json: any = null, type: any = null): Observable<any> {
    let params = 'authorization=' + this.token;

    if (json != null) {
      params = params + '&json=' + encodeURIComponent(JSON.stringify(json));
    }

    if (type != null) {
      params = params + '&type=' + type;
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post(url, params, { headers }).pipe(
      map(res => res as any)
    );
  }
}
